module.exports = __webpack_public_path__ + "img/tp-link_pic4.9159203d.png";